export default {
  user: null,
  expires: null,
  token: null,
  roles: [],
  login: {
    requiresEmail: false,
    resetToken: '',
    email: '',
    confirmEmail: '',
    password: '',
    passwordConfirmation: '',
    userName: ''
  }
}
